import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/EmailMarketing.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../config';
import emailImage from '../assets/emailmarketingimage.png';
import EmailPreview from './EmailPreview';

const apiUrl = config.apiUrl;

const EmailMarketing = () => {
    const [titulo, setTitulo] = useState('');
    const [tituloCorpo, setTituloCorpo] = useState('');
    const [corpo, setCorpo] = useState('');
    const [emails, setEmails] = useState([{ nome: '', email: '' }]);
    const [portalUsers, setPortalUsers] = useState(false);
    const [enviados, setEnviados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewEnviado, setPreviewEnviado] = useState(null);



    useEffect(() => {
        fetchEmails();
    }, []);

    const fetchEmails = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${apiUrl}/emailmarketing/listar`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setEnviados(response.data);
        } catch (error) {
            toast.error('Erro ao buscar e-mails enviados');
        }
    };

    const handleAddDestinatario = () => {
        setEmails([...emails, { nome: '', email: '' }]);
    };

    const handleRemoveDestinatario = (index) => {
        const novos = [...emails];
        novos.splice(index, 1);
        setEmails(novos);
    };

    const handleDestinatarioChange = (index, field, value) => {
        const novos = [...emails];
        novos[index][field] = value;
        setEmails(novos);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!titulo || !corpo) {
            toast.error('Preencha todos os campos obrigatórios');
            return;
        }

        setIsSubmitting(true);
        const token = localStorage.getItem('token');
        try {
            await axios.post(`${apiUrl}/emailmarketing/criar`, {
                titulo,
                tituloCorpo,
                corpo,
                portalUsers,
                emails,
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success('E-mail enviado com sucesso');
            setTitulo('');
            setTituloCorpo('');
            setCorpo('');
            setEmails([{ nome: '', email: '' }]);
            setPortalUsers(false);
            fetchEmails();
        } catch (error) {
            toast.error('Erro ao enviar e-mail');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="emailmarketing-container">
            <h2>Enviar E-mail Marketing</h2>
            <img src={emailImage} alt="Email Marketing" className="emailmarketing-image" />
            <form className="emailmarketing-form" onSubmit={handleSubmit}>
                <div className="emailmarketing-form-group">
                    <label htmlFor="titulo">Título</label>
                    <input type="text" id="titulo" value={titulo} onChange={(e) => setTitulo(e.target.value)} required />
                </div>
                <div className="emailmarketing-form-group">
                    <label htmlFor="titulocorpo">Título Interno do Corpo</label>
                    <input type="text" id="titulocorpo" value={tituloCorpo} onChange={(e) => setTituloCorpo(e.target.value)} />
                </div>
                <div className="emailmarketing-form-group">
                    <label htmlFor="corpo">Corpo</label>
                    <textarea id="corpo" rows="6" value={corpo} onChange={(e) => setCorpo(e.target.value)} required />
                </div>
                <div className="emailmarketing-form-group checkbox-group">
                    <label>
                        Enviar para todos os usuários do portal
                        <input
                            type="checkbox"
                            className="emailmarketing-checkbox"
                            checked={portalUsers}
                            onChange={() => setPortalUsers(!portalUsers)}
                        />


                    </label>
                </div>
                <div className="emailmarketing-form-group">
                    <label>Destinatários</label>
                    <button type="button" onClick={handleAddDestinatario} className="emailmarketing-add-button">
                        Adicionar Destinatário
                    </button>
                    {emails.map((item, index) => (
                        <div key={index} className="emailmarketing-destinatario">
                            <input
                                type="text"
                                placeholder="Nome"
                                value={item.nome}
                                onChange={(e) => handleDestinatarioChange(index, 'nome', e.target.value)}
                                required
                            />
                            <input
                                type="email"
                                placeholder="E-mail"
                                value={item.email}
                                onChange={(e) => handleDestinatarioChange(index, 'email', e.target.value)}
                                required
                            />
                            {emails.length > 0 && (
                                <button
                                    type="button"
                                    className="emailmarketing-remove-button"
                                    onClick={() => handleRemoveDestinatario(index)}
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    ))}

                </div>
                <button
                    type="button"
                    className="emailmarketing-preview-button"
                    onClick={() => setShowPreview(true)}
                >
                    Pré-visualizar Resultado
                </button>

                <button type="submit" className="emailmarketing-submit-button" disabled={isSubmitting}>
                    Enviar
                </button>
                <p className="emailmarketing-help">
                    Use <code>&lt;br/&gt;</code> para quebrar linha e <code>{'{CLIENTE_NOME}'}</code> para se referir ao nome do usuário.
                </p>
            </form>

            <h2>E-mails Enviados</h2>
            <table className="emailmarketing-table">
                <thead>
                    <tr>
                        <th>Título</th>
                        <th>Corpo</th>
                        <th>Destinatários</th>
                    </tr>
                </thead>
                <tbody>
                    {enviados.map((email) => (
                        <tr key={email.id}>
                            <td>{email.titulo}</td>
                            <td>
                                <button
                                    type="button"
                                    className="emailmarketing-preview-button"
                                    onClick={() => setPreviewEnviado(email)}
                                >
                                    Pré-visualizar
                                </button>
                            </td>
                            <td>
                                <ul>
                                    {email.emails?.map((d, idx) => (
                                        <li key={idx}>{d.nome} - {d.email}</li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showPreview && (
                <EmailPreview
                    tituloCorpo={tituloCorpo}
                    corpo={corpo}
                    onClose={() => setShowPreview(false)}
                />
            )}
            {previewEnviado && (
                <EmailPreview
                    tituloCorpo={previewEnviado.tituloCorpo}
                    corpo={previewEnviado.corpo}
                    onClose={() => setPreviewEnviado(null)}
                />
            )}

        </div>
    );
};

export default EmailMarketing;
